<template>
  <v-row :class="device.isDesktop && 'mx-10 mt-2'">
    <v-col cols="12" sm="3">
      <v-row v-if="selectedMenu">
        <category-menu-select-date
          v-if="!device.isDesktop"
          :selected-date="selectedDate"
          @subOneDay="subOneDay"
          :title="$t('pages.category_menu.sentence_1_0')"
          @addOneDay="addOneDay"
        ></category-menu-select-date>
        <v-col cols="12">
          <div v-if="device.isDesktop" class="card-section py-4 text-center">
            {{ $t("pages.category_menu.sentence_3") }}
          </div>
          <shift-box
            v-model="shift"
            :selectedMenu="selectedMenu"
            :shiftEnable="shiftEnable"
          ></shift-box>
        </v-col>
        <v-col cols="12" v-if="shiftAsText && device.isDesktop">
          <v-row>
            <v-col
              v-for="(item, key) in Object.keys(selectedMenu[shiftAsText])"
              :key="key"
              cols="12"
              class="py-1"
            >
              <v-sheet
                :color="category != item ? 'rgba(0, 0, 0, 0.02)' : 'primary'"
                :class="category != item ? 'black--text' : 'white--text'"
                class="px-2 py-4"
                @click="category = item"
                style="border-radius: 8px"
              >
                {{ $store.state.isLatin ? convert(item) : item }}
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" align="center">
      <v-row>
        <category-menu-select-date
          v-if="device.isDesktop"
          :selected-date="selectedDate"
          @subOneDay="subOneDay"
          :title="$t('pages.category_menu.sentence_1_0')"
          @addOneDay="addOneDay"
        ></category-menu-select-date>
        <v-col cols="12" v-if="category && shiftAsText">
          <v-row v-if="!device.isDesktop">
            <v-col
              cols="12"
              v-for="(foodCategory, i) in Object.keys(selectedMenu[shiftAsText])"
              :key="i"
              class="mb-4"
            >
              <h2 class="mb-4 title">{{ foodCategory }}</h2>

              <v-row>
                <v-col
                  cols="12"
                  v-for="(item, j) in selectedMenu[shiftAsText][foodCategory]"
                  :key="j"
                >
                  <category-menu-group-card
                    :item="item"
                    :is-selected="
                      choseItems.some((i) => i.foods.find((ii) => ii.id == item.id))
                    "
                    :disabled="checkDisabled"
                    @subFood="subFood(item)"
                    @addFood="addFood(item)"
                  ></category-menu-group-card>
                  <v-divider
                    v-if="j < selectedMenu[shiftAsText][foodCategory].length - 1"
                  ></v-divider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <template v-else>
            <v-col
              cols="12"
              v-for="(item, index) in selectedMenu[shiftAsText][category]"
              :key="index"
              style="cursor: pointer"
              @click="!checkDisabled && !rolaCompany && addFood(item)"
              class="pt-0"
            >
              <category-menu-group-card
                :item="item"
                :is-selected="
                  choseItems.some((i) => i.foods.find((ii) => ii.id == item.id))
                "
                :disabled="checkDisabled"
                @subFood="subFood(item)"
                @addFood="addFood(item)"
              ></category-menu-group-card>
              <v-divider class="mt-4"></v-divider>
            </v-col>
          </template>
        </v-col>
        <v-col cols="12" v-else>
          <v-alert dense text type="warning" color="primary">
            {{ $t("pages.category_menu.sentence_2") }}
          </v-alert>
          <category-menu-select-date
            :selected-date="selectedDate"
            @subOneDay="subOneDay"
            :title="$t('pages.category_menu.sentence_1_0')"
            @addOneDay="addOneDay"
          ></category-menu-select-date>
        </v-col>
        <v-col cols="12" v-if="!device.isDesktop">
          <v-btn
            block
            color="primary"
            class="white--text"
            @click="!checkDisabled ? (disable ? update() : saveOrder()) : null"
            :disabled="disable && checkDisabled"
            style="position: sticky; text-transform: none"
            height="46"
          >
            <v-icon>mdi-cart-outline</v-icon>
            {{
              disable
                ? $t("pages.category_menu.sentence_8")
                : $t("pages.category_menu.sentence_7")
            }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="3" v-if="device.isDesktop">
      <v-row v-if="selectedMenu">
        <v-col cols="12">
          <div class="card-section py-4 text-center">
            {{ $t("pages.category_menu.sentence_4") }}
          </div>
          <shift-box
            v-model="shift"
            :selectedMenu="selectedMenu"
            :shiftEnable="shiftEnable"
            class="py-3"
          ></shift-box>
        </v-col>
        <v-col
          v-for="(item, i) in choseItems.filter((i) => i.shift === shiftAsText)"
          :key="i"
          cols="12"
          class="py-1"
          :align="!item.foods.length ? 'center' : 'start'"
        >
          <v-sheet color="#fafafa" class="px-2 py-4" style="border-radius: 8px">
            <div v-if="item.foods.length">
              <v-row
                no-gutters
                justify="space-between"
                v-for="(food, ii) in item.foods"
                :key="ii"
              >
                <v-col>
                  <span class="food-box-name">
                    {{ food.quantity && food.quantity + "x" }}
                    {{ food.name }}
                  </span>
                </v-col>
                <v-col cols="auto" v-if="!checkDisabled">
                  <circle-button
                    icon="mdi-close"
                    :tooltip="$t('remove_food')"
                    size="x-small"
                    @click="removeFood(food, item, ii)"
                  ></circle-button>
                </v-col>
              </v-row>
            </div>
            <v-row v-else no-gutters justify="center">
              <v-col>
                <span style="color: rgba(0, 0, 0, 0.16)" class="food-box-name">
                  {{ "Izaberite " + item.category }}
                </span>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
        <v-col cols="12">
          <v-btn
            block
            color="primary"
            class="white--text"
            @click="!checkDisabled ? (disable ? update() : saveOrder()) : null"
            :disabled="disable && checkDisabled"
            style="position: sticky; text-transform: none"
            height="46"
          >
            <v-icon>mdi-cart-outline</v-icon>
            {{
              disable
                ? $t("pages.category_menu.sentence_8")
                : $t("pages.category_menu.sentence_7")
            }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-overlay :value="dialog">
      <v-sheet
        elevation="12"
        max-width="600"
        rounded="lg"
        width="100%"
        class="pa-4 text-center mx-auto"
        light
      >
        <v-icon class="mb-5" color="success" size="112">mdi-check-circle</v-icon>

        <h2 class="text-h5 mb-6">{{ $t("pages.category_menu.sentence_5") }}</h2>

        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ $t("pages.category_menu.sentence_9") }}
        </p>

        <v-divider class="mb-4"></v-divider>

        <div class="text-end">
          <primary-button @click="dialog = false" block>
            {{ $t("pages.category_menu.sentence_6") }}({{ timeleft }})
          </primary-button>
        </div>
      </v-sheet>
    </v-overlay>
  </v-row>
</template>

<script>
import moment from "moment";
import ShiftBox from "@/components/categoryMenu/shiftBox";
import CategoryMenuSelectDate from "@/components/categoryMenu/CategoryMenuSelectDate.vue";
import CategoryMenuGroupCard from "@/components/categoryMenuGroup/CategoryMenuGroupCard.vue";
import conf from "@/config.json";
import convert from "cyrillic-to-latin";
import menuService from "@/services/menu";
import restaurantService from "@/services/restaurant";
import orderService from "@/services/order";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "CategoryMenuGroupOrders",
  mixins: [hasSnackbar],
  components: { ShiftBox, CategoryMenuSelectDate, CategoryMenuGroupCard },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      convert: convert,
      conf: conf,
      moment: moment,
      selectedDate: new Date().toISOString().substr(0, 10),
      menus: [],
      category: null,
      choseItems: [],
      shift: null,
      dialog: false,
      shiftEnable: "all",
      disable: false,
      restaurantOrderTime: null,
      order: null,
      timeleft: 2,
    };
  },
  created() {
    this.getMenues(true);

    restaurantService
      .getRestaurantNewTimes(this.company.restaurant_id)
      .then((res) => {
        this.restaurantOrderTime = res.data.data;
      })
      .catch((error) => {
        this.showErrorSnackbar(error, this.$t("error_loading_restaurant_times"));
      });
  },
  methods: {
    update() {
      let foods = this.choseItems.filter((i) => i.foods.length);

      let data = {
        categories: foods,
        shift: this.shift + 1,
        restaurant_id: this.company.restaurant_id,
        company_id: this.company.pivot ? this.company.pivot.company_id : 0,
        date: this.selectedDate,
        app_type: 1,
      };

      orderService
        .updateGroupFoodOrder(this.order.id, data)
        .then((res) => {
          this.dialog = true;
          if (!(data.foods || []).length) this.disable = false;
          this.timeleft = 2;
          let downloadTimer = setInterval(() => {
            if (this.timeleft <= 0) {
              clearInterval(downloadTimer);
              this.dialog = false;
            }
            this.timeleft -= 1;
          }, 1000);
          this.showSuccessSnackbar(this.$t("order_updated_successfully"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_updating_order"));
        });
    },
    saveOrder() {
      let foods = this.choseItems.filter((i) => i.foods.length);

      let data = {
        categories: foods,
        shift: this.shift + 1,
        restaurant_id: this.company.restaurant_id,
        company_id: this.company.pivot ? this.company.pivot.company_id : 0,
        date: this.selectedDate,
        app_type: 1,
      };

      orderService
        .storeGroupFoodOrder(data)
        .then((res) => {
          this.order = res.data;
          this.disable = true;
          this.dialog = true;

          this.timeleft = 2;
          let downloadTimer = setInterval(() => {
            if (this.timeleft <= 0) {
              clearInterval(downloadTimer);
              this.dialog = false;
            }
            this.timeleft -= 1;
          }, 1000);
          this.showSuccessSnackbar(this.$t("order_created_successfully"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_creating_order"));
        });
    },
    subOneDay() {
      this.disable = false;

      this.selectedDate = this.moment(this.selectedDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");

      this.getMenues();
    },
    addOneDay() {
      this.disable = false;

      this.selectedDate = this.moment(this.selectedDate)
        .add(1, "days")
        .format("YYYY-MM-DD");

      this.getMenues();
    },
    addFood(food) {
      let item = this.choseItems.find(
        (i) => i.category === this.category && i.shift === this.shiftAsText
      );
      this.shiftEnable = this.shiftAsText;

      let foodIndex = item.foods.findIndex((f) => f.id === food.id);
      if (foodIndex > -1) {
        food.quantity++;
        this.$set(item.foods, foodIndex, food);
      } else {
        food.quantity = 1;
        if (this.rolaCompany) item.foods.push(food);
        else item.foods = [food];
      }
    },
    subFood(food) {
      if (food.quantity === 0) return;
      food.quantity--;
      if (food.quantity === 0) {
        let category = this.choseItems.find((i) => i.category === food.category.name);
        let index = category.foods.findIndex((f) => f.id === food.id);
        if (index > -1) category.foods.splice(index, 1);
      }
    },
    removeFood(food, shift, i) {
      shift.foods.splice(i, 1);

      this.shiftEnable = this.choseItems.find(
        (i) => i.shift === this.shiftAsText && i.foods.length
      )
        ? this.shiftAsText
        : "all";

      let menu = this.menus[0][shift.shift][shift.category];
      let foodFromMenu = menu.find((f) => f.id === food.id);
      foodFromMenu.quantity = 0;
    },
    async getMenues(firstLoad = false) {
      if (firstLoad) {
        try {
          let { data } = await restaurantService.checkRestaurantDisabled(
            this.company.restaurant_id
          );
          this.selectedDate = moment(data).format("YYYY-MM-DD");
        } catch (error) {
          this.showErrorSnackbar(error, this.$t("error_loading_restaurant"));
        }
      }

      let fromDate = this.selectedDate;

      this.menus = [];
      menuService
        .getWebAppMenu({ from: fromDate, to: fromDate, type: "rucak" })
        .then((res) => {
          this.menus = res.data;

          orderService
            .getOrdersByDate(this.selectedDate)
            .then((res) => {
              this.order = null;
              if (res.data) {
                this.order = res.data[0];
                this.fillOrder(this.order);
              }
            })
            .catch((error) => {
              this.showErrorSnackbar(error, this.$t("error_loading_orders"));
            });
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_menu"));
        });
    },
    calc(data) {
      this.choseItems = [];
      if (!data) return;

      if (this.selectedMenu.shiftOne) {
        for (let i in this.selectedMenu.shiftOne) {
          this.choseItems.push({
            food: { name: "empty" },
            foods: [],
            category: i,
            shift: "shiftOne",
          });
        }
      }
      if (this.selectedMenu.shiftTwo) {
        for (let i in this.selectedMenu.shiftTwo) {
          this.choseItems.push({
            food: { name: "empty" },
            foods: [],
            category: i,
            shift: "shiftTwo",
          });
        }
      }
      if (this.selectedMenu.shiftThree) {
        for (let i in this.selectedMenu.shiftThree) {
          this.choseItems.push({
            food: { name: "empty" },
            foods: [],
            category: i,
            shift: "shiftThree",
          });
        }
      }
    },
    fillOrder(order) {
      if (!order) return;
      let shift = null;
      if (order.shift === 1) {
        shift = "shiftOne";
        this.shiftEnable = "shiftOne";
        this.shift = 0;
      }
      if (order.shift === 2) {
        shift = "shiftTwo";
        this.shiftEnable = "shiftTwo";
        this.shift = 1;
      }
      if (order.shift === 3) {
        shift = "shiftThree";
        this.shiftEnable = "shiftThree";
        this.shift = 2;
      }

      order.transaction.forEach((product) => {
        let item = this.choseItems.find((i) => {
          return i.shift === shift && i.category === product.food.category.name;
        });
        if (item) {
          // Fill center column (menu) with quantity
          let menu = this.menus[0][item.shift][item.category];
          let food = menu.find((food) => food.id === product.food_id);
          if (!food) return;
          food.quantity = product?.quantity || 0;
          // Fill right column (order) with quantity
          product.food.quantity = product.quantity || 0;

          if (item.foods) item.foods.push(product.food);
          else item.foods = [product.food];

          this.disable = true;
        }
      });
    },
  },
  computed: {
    rolaCompany() {
      return this.user?.type === "company";
    },
    user() {
      return this.$store.state.user.user;
    },
    selectedMenu() {
      return this.menus.find((i) => i.date === this.selectedDate);
    },
    shiftAsText() {
      if (!this.selectedMenu) return;

      let shifts = [];
      if (this.selectedMenu.shiftOne) {
        shifts.push("shiftOne");
      }
      if (this.selectedMenu.shiftTwo) {
        shifts.push("shiftTwo");
      }
      if (this.selectedMenu.shiftThree) {
        shifts.push("shiftThree");
      }

      return shifts[this.shift];
    },
    checkDisabled() {
      if (!this.restaurantOrderTime) return false;

      let day = this.moment().format("dddd").toLowerCase();
      let newDay = this.restaurantOrderTime[day];

      if (
        this.moment().isBefore(
          this.moment(this.selectedDate)
            .set("hour", newDay.time.time_hour)
            .set("minutes", newDay.time.time_minut)
        )
      ) {
        let addDay = newDay.day_before_limit;
        if (
          this.moment()
            .add("days", addDay)
            .diff(this.moment(this.selectedDate).add("days", 1)) >= 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        let addDay = newDay.day_after_limit;
        if (
          this.moment()
            .add("days", addDay)
            .diff(this.moment(this.selectedDate).add("days", 1)) >= 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  watch: {
    shiftAsText() {
      if (!this.selectedMenu) return;
      this.category = Object.keys(this.selectedMenu[this.shiftAsText])[0];
    },
    selectedMenu(menu) {
      if (menu) {
        if (menu.shiftOne) {
          if (this.shift === null) this.shift = 0;
        }
        if (menu.shiftTwo) {
          if (this.shift === null) this.shift = 1;
        }
        if (menu.shiftThree) {
          if (this.shift === null) this.shift = 2;
        }

        this.calc(menu);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card-section {
  border: 1px solid #0000001a;
  background-color: rgba($primary-color, 0.05);
  border-radius: 8px 8px 0 0;
}

.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.9;
}

.food-box-name {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
